export default __webpack_public_path__ + "static/media/telstra2.b35b9e95.jpg";